import {
    SHIP_CLS_LIST_GET,
    SHIP_CLS_LIST_GET_F,
    SHIP_CLS_LIST_GET_R,
    SHIP_CLS_SELECTED_SET
} from '../actionType'

const initialState = {
    classification: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedClassification: null,
}

export default function shipClassificationReducer (state = initialState, action : any)  {
    switch (action.type) {
        case SHIP_CLS_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case SHIP_CLS_LIST_GET_F:
            console.log('action called')
            console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                classification: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case SHIP_CLS_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case SHIP_CLS_SELECTED_SET:
            return {
                ...state,
                selectedClassification: action.payload
            }
        default:
            return state
    }
}